// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__25Aer","previous":"Pagination_previous__3OfpW","next":"Pagination_next__QpFFK"};